import { getCallable } from "../../_sdk/client";
import { apiName, endpoints } from "./endpoints";
import type {
    GetWorkspaceRequest,
    GetWorkspaceResponse,
    UpdateWorkspaceRequest,
    UpdateWorkspaceResponse,
    ParseSamlMetadataRequest,
    ParseSamlMetadataResponse,
    VerifyWorkspaceDomainRequest,
    VerifyWorkspaceDomainResponse,
    ConnectWorkspaceIntegrationRequest,
    ConnectWorkspaceIntegrationResponse,
    DisconnectWorkspaceIntegrationRequest,
    DisconnectWorkspaceIntegrationResponse,
} from "./types";

export { apiName };

const getWorkspace = getCallable<GetWorkspaceRequest, GetWorkspaceResponse>(
    apiName,
    "getWorkspace",
    {
        ...endpoints.getWorkspace,
        composer: request => {
            return {
                url: `/workspaces/${request.workspaceId}`,
                options: {
                    method: "GET"
                }
            };
        }
    });

const updateWorkspace = getCallable<UpdateWorkspaceRequest, UpdateWorkspaceResponse>(
    apiName,
    "updateWorkspace",
    {
        ...endpoints.updateWorkspace,
        composer: request => {
            return {
                url: `/workspaces/${request.workspaceId}`,
                options: {
                    method: "PUT",
                    body: JSON.stringify(request)
                }
            };
        }
    });

const verifyWorkspaceDomain = getCallable<VerifyWorkspaceDomainRequest, VerifyWorkspaceDomainResponse>(
    apiName,
    "verifyWorkspaceDomain",
    {
        ...endpoints.verifyWorkspaceDomain,
        composer: request => {
            return {
                url: `/workspaces/${request.workspaceId}/verify-domain`,
                options: {
                    method: "POST"
                }
            };
        }
    });

const parseSamlMetadata = getCallable<ParseSamlMetadataRequest, ParseSamlMetadataResponse>(
    apiName,
    "parseSamlMetadata",
    {
        ...endpoints.parseSamlMetadata,
        composer: request => {
            return {
                url: `/workspaces/${request.workspaceId}/parse-saml-metadata`,
                options: {
                    method: "POST",
                    body: JSON.stringify(request)
                }
            };
        }
    });

const connectWorkspaceIntegration = getCallable<ConnectWorkspaceIntegrationRequest, ConnectWorkspaceIntegrationResponse>(
    apiName,
    "connectWorkspaceIntegration",
    {
        ...endpoints.connectWorkspaceIntegration,
        composer: request => {
            return {
                url: `/workspaces/${request.workspaceId}/integrations/${request.integrationType}/connect`,
                options: {
                    method: "POST",
                    body: JSON.stringify(request)
                }
            };
        }
    }
);

const disconnectWorkspaceIntegration = getCallable<DisconnectWorkspaceIntegrationRequest, DisconnectWorkspaceIntegrationResponse>(
    apiName,
    "disconnectWorkspaceIntegration",
    {
        ...endpoints.disconnectWorkspaceIntegration,
        composer: request => {
            return {
                url: `/workspaces/${request.workspaceId}/integrations/${request.integrationType}/disconnect`,
                options: {
                    method: "POST"
                }
            };
        }
    });

export const callables = {
    getWorkspace,
    updateWorkspace,
    verifyWorkspaceDomain,
    parseSamlMetadata,
    connectWorkspaceIntegration,
    disconnectWorkspaceIntegration,
};
